"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      d: "M9.057 6.28L6.22 9.12c-.773.687-1.947.652-2.677-.077-.73-.73-.765-1.903-.08-2.674l3.674-3.672c.456-.432 1.17-.432 1.625 0 .445.45.445 1.174 0 1.624l-3.168 3.16c-.085.093-.213.133-.335.105-.123-.028-.22-.12-.258-.24-.037-.12-.007-.25.08-.34l2.354-2.35c.18-.18.18-.47 0-.65-.18-.18-.472-.18-.652 0L4.428 6.363c-.238.236-.372.557-.372.892 0 .336.134.657.372.893.5.475 1.287.475 1.786 0l3.164-3.167c.758-.814.736-2.08-.05-2.868-.787-.786-2.056-.808-2.87-.05l-3.673 3.67C1.755 6.875 1.807 8.62 2.9 9.7c1.093 1.076 2.84 1.103 3.967.06l2.84-2.836c.118-.117.163-.286.12-.445-.042-.16-.166-.285-.325-.327-.16-.043-.33.003-.445.12v.008z",
      fill: "currentColor",
      fillRule: "nonzero"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Attachment.js.map